import React from 'react';
import { AiOutlineBell } from 'react-icons/ai';
import './NotificationsPage.css';

// Structural placeholder — no notification data/backend exists yet.
const NotificationsPage = () => {
  return (
    <div className="np-container">
      <div className="np-header">
        <h1 className="np-title">Notifications</h1>
      </div>
      <div className="np-empty">
        <div className="np-empty-icon">
          <AiOutlineBell size={26} />
        </div>
        <p className="np-empty-text">No notifications yet</p>
      </div>
    </div>
  );
};

export default NotificationsPage;
